exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#basis .el-dialog__header {\n  text-align: center !important;\n  background-color: rgb(21, 106, 195);\n  /* 将这里的颜色值替换为你想要的颜色 */\n}\n#basis .el-dialog__header .el-dialog__headerbtn {\n  height: 20px;\n  width: 18px;\n  text-align: center;\n  background-color: #fff;\n}\n#basis .el-dialog__header .el-dialog__title {\n  color: #FFFFFF !important;\n}\n.label-qus {\n  background-color: rgb(22, 155, 213);\n  display: inline-block;\n  width: 60px;\n  text-align: center;\n  height: 25px;\n  line-height: 25px;\n  border-radius: 10px;\n  color: #fff\n}\n.img {\n  width: 180px;\n  /* height: 150px; */\n  /* margin: 0 4% 0 0; */\n}\n", ""]);

// exports
